// extracted by mini-css-extract-plugin
export default {"modal":"bu","topline":"cu","img":"eu","textcontents":"fu","heading":"gu","copy":"hu","link":"iu","close":"ju","modalinner":"ku","container":"lu"};
    if(module.hot) {
      // 1713809675734
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  